import QcDetailsApi from "../../services/api/QcDetails";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import ErrorMsgs from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";

function handleError(err) {
  console.log("error in qc details actions:", err);
}

export const setQcDetails = (payload) => {
  return {
    type: ActionTypes.SET_QC_DETAILS,
    payload,
  };
};

export const setQcAdditionalData = (payload) => {
  return {
    type: ActionTypes.SET_QC_ADDITIONAL_DATA,
    payload,
  };
};

export const setCurrentFeId = (FeId) => {
  const payload = {
    feid: FeId,
  };
  return {
    type: ActionTypes.SET_CURRENT_FEID,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_QC,
    payload,
  };
};

export const getQcDetails = (FeId) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await QcDetailsApi.getQcDetails(FeId);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setQcDetails(response));
      dispatch(setCurrentFeId(FeId));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getQcAdditionalData = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await QcDetailsApi.getQcAdditionalData();
    dispatch(setLoader(false));
    if (response) {
      dispatch(setQcAdditionalData(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const saveQcDetails = (FeId, payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const response = await QcDetailsApi.saveQcDetails(FeId, payload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.UPDATION_SUCCESS,
        })
      );
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const approveQcDetails = (FeId, payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const response = await QcDetailsApi.approveQcDetails(FeId, payload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.QC_APPROVED_SUCCESSFULLY,
        })
      );
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const updateQcField = (FeId, payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const response = await QcDetailsApi.updateQcField(FeId, payload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.UPDATION_SUCCESS,
        })
      );
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
